import { render } from "./ListeCategorieAbonne.vue?vue&type=template&id=456113b2&ts=true"
import script from "./ListeCategorieAbonne.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieAbonne.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__